import styled from "styled-components";

const BannerSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, 
    #5bcffa 0%, #f5abb9 25%, #ffffff 50%, #f5abb9 75%, #5bcffa 100%);
    overflow-y: scroll;
`;

export default BannerSection;